import React, { Fragment } from 'react';
import { Box, Card, Flex, Grid, Inset, Text } from '@radix-ui/themes';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectDevice } from 'store/slices/common';
import { localList } from 'app/constants';

import './style.scss';

export default function BoardImageItems({ itemType, tableData, onCellClick }) {
  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';
  const location = useLocation();

  return (
    <Grid columns={isMobile ? '1' : '4'} className={`board-image-items type-${itemType}`}>
      {tableData.map((item, index) => {
        return (
          <Link to={`${location.pathname}/detail/${item?.postNo}`} key={item?.postNo || index}>
            <Card className="board-card">
              {item?.thumbnail === null ? (
                <Box className={`no-image type-${itemType}`}></Box>
              ) : (
                <Inset
                  clip="padding-box"
                  side={itemType === 'list' ? 'left' : 'top'}
                  className="image-box"
                  style={{ backgroundImage: `url(${item?.thumbnail})` }}
                >
                  <img src={item?.thumbnail} alt="" />
                </Inset>
              )}
              <Box className="card-box">
                <Box className="board-extra">
                  <Text className={`chips local ${localList.find(local => local.name === item?.region)?.en}`}>{item?.region}</Text>
                </Box>
                <Box className="card-head">
                  <Text as="p" className={`${isMobile ? 'body2 font-bold' : 'sub-title'} ellipsis fix-2line`}>
                    {item?.title}
                  </Text>
                </Box>
                {/* 첨부파일 임시 주석 */}
                {/* {item.files.length > 0 && (
                  <Box className="card-body">
                    {item?.files?.map(el => (
                      <Text as="p" className="icon-clip">
                        <Text>{el.originalName}</Text>
                      </Text>
                    ))}
                  </Box>
                )} */}
                <Box className="card-footer">
                  <Flex align="center">
                    <Text>{item?.createDate && new Date(item?.createDate).toISOString().split('T')[0]}</Text>
                    <Box className="view">
                      <img src={require('assets/images/icon/icon-view.svg').default} alt="" />
                      <Text className="view-count">
                        <span className="hidden">조회수</span>
                        {item?.viewCount}
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              </Box>
            </Card>
          </Link>
        );
      })}
    </Grid>
  );
}
